import MLIcon from '../../../../MLIcon/MLIcon';
import MLTooltip from '../../../../MLTooltip';
import s from './StudentInfo.module.css';
import { Fragment } from 'react';

export const StudentInfo = ({
  email,
  thirdPartyUserId,
  isBrokenSyncReefGrades,
  user,
  isDesktop,
  hidden,
  isStudentIdRequiredChecked,
}) => {
  const renderThirdPartyUserId = () =>
    isStudentIdRequiredChecked ? (
      <Fragment>
        {isDesktop && <hr className={s.infoDivider} />}
        <div className={s.thirdPartyUserId}>
          <span className={s.thirdPartyUserIdLabel}>
            ID: {thirdPartyUserId || 'not entered'}
          </span>
        </div>
      </Fragment>
    ) : null;

  const renderIClickerIcon = () => {
    const isIClicker = user?.isReefLinked && user?.reefCourseId;

    const icon = isBrokenSyncReefGrades ? (
      <MLTooltip
        content={`
                iClicker Connection 
                Not Established
              `}
      >
        <MLIcon
          type="unlink"
          role="presentation"
          className={s.brokenReefSyncIcon}
          testId="isg-broken-sync-icon"
        />
      </MLTooltip>
    ) : (
      <MLTooltip content={`Connected to iClicker`}>
        <MLIcon
          type="link"
          role="presentation"
          className={s.reefSyncIcon}
          testId="isg-iclicker-connected-icon"
        />
      </MLTooltip>
    );

    return isIClicker ? (
      <Fragment>
        {isDesktop && <hr className={s.infoDivider} />}
        <div className={s.isIClicker}>{icon}</div>
      </Fragment>
    ) : null;
  };

  return (
    !hidden && (
      <div className={s.studentInfo}>
        <span className={s.studentEmail}>{email}</span>
        {renderThirdPartyUserId()}
        {renderIClickerIcon()}
      </div>
    )
  );
};
